// extracted by mini-css-extract-plugin
export default {"icon":"icon__diTAw","dialog":"dialog__g-PR-","dialogContent":"dialogContent__oIP9V","dialogHead":"dialogHead__TwBdq","dialogClose":"dialogClose__7uA09"};